module.exports = __webpack_public_path__ + "static/media/svg-3.3a5de69c.svg";